import type {
  Ingredient,
  IngredientCreateInput,
  IngredientUnit,
  IngredientUpdateInput,
  IngredientUnitInput,
} from '@/domain/entities/ingredient.entity'
import type { IngredientDto, IngredientUnitDto } from './ingredient.dto'

export const ingredientMapper = {
  toUnit(dto: IngredientUnitDto): IngredientUnit {
    return {
      unitId: dto.unit_id,
      unitName: dto.unit_name,
      ord: dto.ord,
      perLower: dto.per_lower,
      factorBase: dto.factor_base,
    }
  },

  toIngredient(dto: IngredientDto): Ingredient {
    return {
      id: dto.id,
      outletId: dto.outlet_id,
      sku: dto.sku ?? null,
      name: dto.name,
      baseUnitId: dto.base_unit_id,
      baseUnitName: dto.base_unit_name,
      stockQty: dto.stock_qty,
      stockValue: dto.stock_value,
      lastCostMilli: dto.last_cost_milli,
      costSupplier: dto.cost_supplier,
      minStock: dto.min_stock,
      sellQtyBase: dto.sell_qty_base ?? null,
      active: dto.active,
      units: (dto.units ?? []).map(ingredientMapper.toUnit),
    }
  },

  toCreateBody(input: IngredientCreateInput) {
    return {
      name: input.name.trim(),
      sku: input.sku?.trim() || undefined,
      min_stock: input.minStock,
      cost_supplier: input.costSupplier ?? undefined,
      sell_qty_base: input.sellQtyBase ?? undefined,
      units: input.units.map((u) => ({
        unit_id: u.unitId,
        per_lower: u.perLower,
      })),
    }
  },

  toUpdateBody(input: IngredientUpdateInput) {
    return {
      name: input.name?.trim(),
      sku: input.sku === '' ? null : input.sku?.trim(), // Allow clearing SKU if BE supports it, usually done via pointer
      min_stock: input.minStock,
      cost_supplier: input.costSupplier,
      sell_qty_base: input.sellQtyBase,
      clear_sell_qty_base: input.clearSellQtyBase,
      active: input.active,
    }
  },
}
